import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const usePropertyTypesAndFeatures = () => {
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [additionalFeatures, setAdditionalFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMappingData = async () => {
      try {
        setLoading(true);

        const [propertyTypesResponse, featuresResponse] = await Promise.all([
          supabase
            .from('property_types')
            .select('key, label')
            .order('label'),
          supabase
            .from('additional_features')
            .select('key, label, icon_svg')
            .order('label')
        ]);

        if (propertyTypesResponse.error) throw propertyTypesResponse.error;
        if (featuresResponse.error) throw featuresResponse.error;

        setPropertyTypes(propertyTypesResponse.data);
        setAdditionalFeatures(featuresResponse.data);
      } catch (err) {
        console.error('Error fetching mapping data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMappingData();
  }, []);

  const getPropertyTypeLabel = (key) => {
    const type = propertyTypes.find(t => t.key === key);
    return type?.label || key;
  };

  const getFeatureLabel = (key) => {
    const feature = additionalFeatures.find(f => f.key === key);
    return feature?.label || key;
  };

  const getFeature = (key) => {
    return additionalFeatures.find(f => f.key === key) || null;
  };

  return {
    propertyTypes,
    additionalFeatures,
    loading,
    error,
    getPropertyTypeLabel,
    getFeatureLabel,
    getFeature
  };
};